import { Moment } from 'moment';
import { Gender } from './gender';
import { RelationshipType } from './relationship-type';
import { State } from 'models';

export interface IContact {
  id: string;
  contactType: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  ndisNumber: string;
  gender: Gender;
  dob?: moment.Moment;
  mobileNumber: string;
  addressLine1: string;
  addressLine2: string;
  postcode: string;
  state: State;
  invoices: ContactInvoice[];
  hasGuardian: boolean;
  guardianFullName: string;
  guardianFirstName: string;
  guardianLastName: string;
  guardianEmail: string;
  guardianPhoneNumber: string;
  guardianRelationshipType: RelationshipType;
  organisationName: string;
  hasOrganisationContact: boolean;
  organisationContactName: string;
  organisationContactMobileNumber: string;
  organisationContactEmail: string;

  dobMoment: Moment;
  invoicesObj: any;
  expanded: boolean;
  name: string;
}

export enum RoleType {
  AccountsDepartment = 'AccountsDepartment',
  Coordinator = 'Coordinator',
  NDISContact = 'NDISContact',
  Other = 'Other',
  OtherGuardian = 'OtherGuardian',
  PlanManager = 'PlanManager',
}

export const RoleTypeToText = (e: RoleType) => {
  switch (e) {
    case RoleType.AccountsDepartment:
      return 'Accounts Deparment';
    case RoleType.NDISContact:
      return 'NDIS Coordinator';
    case RoleType.OtherGuardian:
      return 'Other Guardian';
    case RoleType.PlanManager:
      return 'Plan Manager';
  }
  return e;
};

const buildDropdownOption = (e: RoleType) => {
  return { value: e, text: RoleTypeToText(e) };
};

export interface ContactInvoice {
  email: string;
  roleType: RoleType;
}

export const roles = [
  buildDropdownOption(RoleType.AccountsDepartment),
  buildDropdownOption(RoleType.Coordinator),
  buildDropdownOption(RoleType.NDISContact),
  buildDropdownOption(RoleType.OtherGuardian),
  buildDropdownOption(RoleType.Other),
  buildDropdownOption(RoleType.PlanManager),
];
